import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from 'react-icons/md';

type Props = {
  showCompleted: boolean;
  completedCount: number;
  onToggle: () => void;
};

/**
 * 対応済み選考予定の表示/非表示を切り替えるトグルボタン
 */
export const CompletedStepsToggleButton: React.FC<Props> = ({
  showCompleted,
  completedCount,
  onToggle,
}) => {
  const Icon = showCompleted
    ? MdOutlineKeyboardArrowUp
    : MdOutlineKeyboardArrowDown;
  const label = showCompleted
    ? '対応済みの選考予定を非表示にする'
    : `${completedCount}件の対応済みの選考予定を表示`;

  return (
    <button
      type="button"
      aria-expanded={showCompleted}
      onClick={onToggle}
      className="flex items-center justify-center gap-8 text-link text-base underline hover:opacity-70"
    >
      <Icon size={20} aria-hidden="true" />
      {label}
    </button>
  );
};
